// Écritures du bouton « Découper ». Mêmes routes que la saisie manuelle :
// - R garde son id : PATCH /api/affectation par le dataProvider, comme
//   l'écran d'édition (hooks care checkAffectation + computeTotalDuration) ;
// - chaque morceau suivant : POST /manageAffectation/createBundle, comme le
//   formulaire de création (validation, durée, dates calées, transaction).
// Tous les morceaux suivants partent dans un seul createBundle : care les
// valide tous, puis les insère ensemble, ou n'en insère aucun.

import { buildPlanning } from '../helper';

const messageOf = (error) => {
  if (!error) {
    return 'erreur inconnue';
  }
  if (typeof error === 'string') {
    return error;
  }
  return (
    (error.body && error.body.message) || error.message || 'erreur inconnue'
  );
};

// Bundles des morceaux à créer, à partir des valeurs du formulaire d'édition
// (jours et horaires éventuellement modifiés).
export const buildEditBundles = (values, pieces) => {
  const planning = buildPlanning(values);
  return pieces.map((piece) => {
    // `original` est un repère du backoffice, jamais envoyé à care.
    return {
      contract_id: values.contract_id,
      type: 'Remplacement',
      cleaner_ids: [values.cleaner_id],
      catalog_item_id: values.catalog_item_id,
      leave_id: piece.leave_id,
      start_date: piece.start_date,
      end_date: piece.end_date,
      planning,
    };
  });
};

// Création : le morceau `original` (celui du congé saisi) garde l'id préparé
// par le formulaire, les autres reçoivent leur id de care.
export const buildCreateRecords = (record, pieces) => {
  return pieces.map((piece) => {
    const bundle = {
      ...record,
      leave_id: piece.leave_id,
      start_date: piece.start_date,
      end_date: piece.end_date,
    };
    if (!piece.original) {
      delete bundle.id;
    }
    return bundle;
  });
};

export const splitOriginal = (pieces) => {
  const original =
    pieces.find((piece) => {
      return piece.original;
    }) || pieces[0];
  return {
    original,
    others: pieces.filter((piece) => {
      return piece !== original;
    }),
  };
};

/**
 * @returns {Promise<Object>} `{ ok: true, created }`, ou
 *   `{ ok: false, stage: 'patch' | 'create', message, compensated,
 *   compensationMessage, pieces }`
 */
export const executeEditSplit = async ({
  dataProvider,
  postJson,
  record,
  values,
  pieces,
}) => {
  const { original: first, others: followers } = splitOriginal(pieces);
  const firstData = {
    ...values,
    leave_id: first.leave_id,
    start_date: first.start_date,
    end_date: first.end_date,
  };

  try {
    await dataProvider.update('affectation', {
      id: record.id,
      data: firstData,
      previousData: record,
    });
  } catch (error) {
    return {
      ok: false,
      stage: 'patch',
      message: messageOf(error),
      compensated: true,
      pieces,
    };
  }

  if (!followers.length) {
    return { ok: true, created: 0 };
  }

  let failure = null;
  try {
    const result = await postJson({
      url: '/manageAffectation/createBundle',
      payload: buildEditBundles(values, followers),
    });
    if (!result || result.success !== true) {
      failure = messageOf(result && result.message);
    } else {
      return { ok: true, created: result.createdAffectation };
    }
  } catch (error) {
    failure = messageOf(error);
  }

  // Compensation : R reprend ses valeurs d'avant le découpage.
  try {
    await dataProvider.update('affectation', {
      id: record.id,
      data: record,
      previousData: firstData,
    });
    return {
      ok: false,
      stage: 'create',
      message: failure,
      compensated: true,
      pieces,
    };
  } catch (error) {
    return {
      ok: false,
      stage: 'create',
      message: failure,
      compensated: false,
      compensationMessage: messageOf(error),
      previousEnd: record.end_date,
      pieces,
    };
  }
};
